// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-43122f12] .el-tabs__item {\n  height: 32px;\n  line-height: 32px;\n}\n.table[data-v-43122f12] {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
